import * as React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { VingleURL } from "@vingle/wtf-sdk/url";

const AutoLinkTextWrapper = styled.span`
  .url-link {
    text-decoration: underline;
    color: ${props => props.theme.blue1000};
  }
`;

const UserLink = styled(Link)`
  font-weight: ${props => props.theme.weightBold};
  color: ${props => props.theme.blue900};
`;

const LINK_REGEXP = /(((http|https|ftp):\/\/|(www\.))[^\s(){}<>"”’]*[^\s.;,(){}<>"”’])|(([a-zA-Z0-9._%+-])+@[^\s(){}<>"”’]*[^\s.;,(){}<>"”’]\.[a-zA-z]+)|((^|\W)@([a-zA-Z0-9]+))/;

class Linker {
  private readonly elements: Array<
    HTMLAnchorElement | string | React.ReactElement<any>
  >;
  constructor() {
    this.elements = [];
  }

  public getElements() {
    return this.elements;
  }

  public addText(text: string) {
    if (text) {
      this.elements.push(text);
    }
  }
  public addUrlLink(url: string, text: string, index: number) {
    const encodeUrl = encodeURI(url);
    const style = { textDecoration: "underline" };

    this.elements.push(
      <a
        className="url-link"
        href={encodeUrl}
        target="_blank"
        rel="nofollow"
        key={index}
        style={style}
      >
        {text}
      </a>,
    );
  }
  public addUserLink(username: string, text: string) {
    const userLocation = new VingleURL.UserShow({
      username,
    });
    this.elements.push(
      <UserLink
        to={userLocation.toString()}
        key={`autolinker_userlink_${username}`}
      >
        <span>@</span>
        {text}
      </UserLink>,
    );
  }
}

const AutolinkText = React.memo(
  ({
    content,
    ...rest
  }: { content: string } & React.HTMLAttributes<HTMLSpanElement>) => {
    if (!content) return <br />;

    const elements = React.useMemo(() => {
      const linker = new Linker();
      let match = content.match(LINK_REGEXP);
      let index = 0;
      while (match) {
        const i = match.index as number;
        linker.addText(content.substr(0, i));
        if (match[1]) {
          let url = match[0];
          if (match[4]) {
            url = `//${url}`;
          }
          linker.addUrlLink(url, match[0], index);
        } else if (match[5]) {
          linker.addUrlLink(`mailto:${match[0]}`, match[0], index);
        } else if (match[7]) {
          linker.addUserLink(match[9], match[9]);
        }
        content = content.substring(i + match[0].length);
        match = content.match(LINK_REGEXP);
        index += 1;
      }
      linker.addText(content);
      return linker.getElements();
    }, [content]);
    return <AutoLinkTextWrapper {...rest}>{elements}</AutoLinkTextWrapper>;
  },
);

export default AutolinkText;
